<template>
  <div class="col-xs-12 p-0">
    <div class="col-xs-12 header-wrapper">
      <div
        class="col-xs-12 mb-20 p-0 d-flex align-items-center justify-space-between xs-flex-column"
      >
        <div
          class="page-title d-flex align-items-center col-gap-20 col-xs-12 col-sm-6 col-md-7 p-0"
        >
          <img
            @click="navigateToDashboard"
            class="cursor-pointer"
            src="/static/images/icons/chevron_left.svg"
            alt="download-icon"
          />
          <span>{{ headLineType === 'mainheadline' ? 'Headlines' : 'Featured Content' }}</span>
        </div>
        <div class="d-flex col-xs-12 align-items-center col-sm-6 col-md-5 col-gap-20 p-0">
          <div class="search-container p-0 col-xs-10">
            <search-box v-model="headLineSearch" @getList="resetSelectedHeadlines"></search-box>
          </div>
          <button
            :class="{
              'gray-out':
                headLineType === 'mainheadline'
                  ? headlinesList.length === 8
                  : headlinesList.length === 12
            }"
            class="btn emergo-green-button"
            @click="addEditHeadLine()"
          >
            <div class="d-flex align-items-center">
              <img src="/static/images/icons/add.svg" alt="add-icon" />
              <span class="pl-5 xs-hide">Add</span>
            </div>
          </button>
          <el-popover
            v-if="
              headLineType === 'mainheadline'
                ? headlinesList.length === 8
                : headlinesList.length === 12
            "
            class="cursor-pointer"
            placement="bottom-end"
            trigger="click"
            @show="infoActive = true"
            @hide="infoActive = false"
            width="350"
          >
            <div class="limit_popover_txt">
              <span v-if="headLineType === 'featuredcontent'">
                Max limit of 12 FC entries. Please delete past entries
              </span>
              <span v-if="headLineType === 'mainheadline'">
                Max 8 main headlines can be added. Please delete and try again
              </span>
            </div>
            <img
              class="info-img"
              src="/static/images/icons/info_icon.svg"
              v-if="!infoActive"
              slot="reference"
            />
            <img
              class="info-img"
              src="/static/images/icons/info_icon_active.svg"
              v-if="infoActive"
              slot="reference"
            />
          </el-popover>
          <!-- <base-tooltip :content="`Max limit reached`" :disabled="disableTooltip">
            <button :class="{'gray-out': headLineType === 'mainheadline' ? headlinesList.length === 8 : headlinesList.length === 12}" class="btn emergo-green-button" @click="addEditHeadLine()">
            <div class="d-flex align-items-center">
              <img src="/static/images/icons/add.svg" alt="add-icon">
              <span class="pl-5 xs-hide">Add Headline</span>
            </div>
          </button>
          </base-tooltip> -->
        </div>
      </div>
      <div class="col-xs-12 d-flex justify-space-between p-0 count-section">
        <div class="list-count font-18 text-secondary mb-0 fw-400" v-if="!isSearchByHeadLine">
          {{ headlinesList.length }}
          {{ headLineType === 'mainheadline' ? 'Headlines' : 'Contents' }}
        </div>
        <div v-else-if="isSearchByHeadLine">
          <div class="list-count font-18 text-secondary mb-0 fw-400">
            {{ filteredHeadlines.length }} result(s) found
          </div>
          <div class="text-secondary font-16">
            out of {{ headlinesList.length }}
            {{ headLineType === 'mainheadline' ? 'Headlines' : 'Contents' }}
          </div>
        </div>
        <button
          @click="deleteHeadLines"
          :disabled="!selectedHeadlines.length"
          class="btn btn-delete font-18 p-0 d-flex align-items-center justify-content-end col-gap-10 fw-400"
        >
          <i class="fa fa-trash"></i> <span>Delete</span>
        </button>
      </div>
    </div>
    <div class="table-responsive common-table col-xs-12 p-0">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 40px" class="first-col sticky">
              <span class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    v-model="isSelectAllHeadLines"
                    @change="setSelectedHeadlines"
                  />
                  <span class="cr">
                  </span>
                </label>
              </span>
            </th>
            <th
              @click="sortBy('title')"
              :class="{
                active: sortKey === 'title',
                'w-40p': headLineType === 'featuredcontent',
                'w-60p': headLineType === 'mainheadline'
              }"
            >
              Document Name
              <span class="sort sortPosition" :class="sortOrders['title'] > 0 ? 'asc' : 'desc'">
              </span>
            </th>
            <th :style="{ width: headLineType === 'featuredcontent' ? '10%' : '20%' }"></th>
            <th
              v-if="headLineType === 'featuredcontent'"
              class="text-nowrap"
              @click="sortBy('start_date')"
              :class="{ active: sortKey === 'start_date' }"
            >
              Start Date
              <span
                class="sort sortPosition"
                :class="sortOrders['start_date'] > 0 ? 'asc' : 'desc'"
              >
              </span>
            </th>
            <th
              v-if="headLineType === 'featuredcontent'"
              class="text-nowrap"
              @click="sortBy('end_date')"
              :class="{ active: sortKey === 'end_date' }"
            >
              End Date
              <span class="sort sortPosition" :class="sortOrders['end_date'] > 0 ? 'asc' : 'desc'">
              </span>
            </th>
            <th
              v-if="headLineType === 'mainheadline'"
              class="text-nowrap"
              @click="sortBy('display_date')"
              :class="{ active: sortKey === 'display_date' }"
            >
              Created Date
              <span
                class="sort sortPosition"
                :class="sortOrders['display_date'] > 0 ? 'asc' : 'desc'"
              >
              </span>
            </th>
          </tr>
        </thead>
        <tbody ref="tbodyBox">
          <tr
            @click="addEditHeadLine('edit', headline)"
            v-for="headline in filteredHeadlines"
            class="cursor-pointer"
            :class="{ 'row-active': selectedHeadlines.includes(headline.id) }"
            :key="headline.id"
          >
            <td style="width: 40px" class="first-col sticky">
              <span class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    v-model="isSelectAllHeadLines"
                    @change="setSelectedHeadlines"
                  />
                  <span class="cr">
                  </span>
                </label>
              </span>
            </td>
            <td>
              {{ headline.title }}
            </td>
            <td></td>
            <td v-if="headLineType === 'featuredcontent'">
              {{ headline.start_date | dateFormat }}
            </td>
            <td v-if="headLineType === 'featuredcontent'">{{ headline.end_date | dateFormat }}</td>
            <td v-if="headLineType === 'mainheadline'">
              {{ headline.display_date | dateFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="filteredHeadlines.length == 0 && !loaderStatus" class="no-records-found">
        No Records Found
      </div>
    </div>
    <delete-headline-popup
      @refreshHeadLinesList="fetchNewList"
      :selectedHeadlines="selectedHeadlines"
      :headLineType="headLineType"
    ></delete-headline-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import { cloneDeep, orderBy } from 'lodash';
import { Popover } from 'element-ui';
import Loader from '../../UIComponents/Loader.vue';
import DeleteHeadlinePopup from './DeleteHeadLinePopup.vue';
import SearchBox from '../../UIComponents/SearchBox.vue';
import BaseTooltip from '../../Common/BaseTooltip.vue';
import { getMainHeadlines, getAllFeaturedContent } from '../../../apis/dashboard';

export default {
  props: {
    roleId: Number
  },

  data() {
    return {
      headLineType: '',
      loaderStatus: false,
      sortKey: '',
      sortOrders: {},
      isSelectAllHeadLines: false,
      headLineSearch: '',
      headlinesList: [],
      filteredHeadlines: [],
      selectedHeadlines: [],
      infoActive: false,
      isSearchByHeadLine: false
    };
  },
  components: {
    BaseTooltip,
    DeleteHeadlinePopup,
    Loader,
    SearchBox,
    'el-popover': Popover
  },
  computed: {
    disableTooltip() {
      return this.headLineType === 'mainheadline'
        ? !(this.headlinesList.length === 8)
        : !(this.headlinesList.length === 12);
    }
  },
  async created() {
    this.headLineType = this.$route.params.type;
    if (
      ['mainheadline', 'featuredcontent'].includes(this.headLineType) &&
      [5, 7].includes(this.roleId)
    ) {
      await this.fetchHeadLinesList();
    } else this.$router.push('/layout/dashboard');
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('Do MMM YYYY');
    }
  },

  // watch: {
  //   headLineSearch() {
  //     this.resetSelectedHeadlines();
  //   },
  // },

  methods: {
    async fetchHeadLinesList() {
      this.loaderStatus = true;
      await this.getHeadlines();
      this.loaderStatus = false;
    },

    async fetchNewList() {
      this.isSelectAllHeadLines = false;
      this.selectedHeadlines = [];
      this.headLineSearch = '';
      $('#delete-headline-popup').modal('hide');
      await this.fetchHeadLinesList();
    },

    resetSelectedHeadlines() {
      if (this.headLineSearch) {
        this.setFilteredHeadLines();
        this.isSearchByHeadLine = true;
      } else if (this.isSearchByHeadLine) {
        this.isSearchByHeadLine = false;
        this.setFilteredHeadLines();
      }
    },

    setFilteredHeadLines() {
      this.isSelectAllHeadLines = false;
      this.selectedHeadlines = [];
      this.filteredHeadlines = this.headlinesList.filter((headline) =>
        headline.title.toLowerCase().includes(this.headLineSearch.toLowerCase())
      );
    },

    setSelectedHeadlines() {
      if (this.isSelectAllHeadLines)
        this.selectedHeadlines = this.filteredHeadlines.map((headline) => headline.id);
      else this.selectedHeadlines = [];
    },

    setIsSelectAllHeadLines() {
      this.isSelectAllHeadLines = this.selectedHeadlines.length === this.filteredHeadlines.length;
    },

    async getHeadlines() {
      let regulatoryHeadLines = {};
      if (this.headLineType === 'mainheadline') {
        regulatoryHeadLines = await getMainHeadlines();
      } else if (this.headLineType === 'featuredcontent')
        regulatoryHeadLines = await getAllFeaturedContent();
      this.headlinesList = regulatoryHeadLines.data;
      this.filteredHeadlines = cloneDeep(this.headlinesList);
    },

    addEditHeadLine(actionType = 'add', headLine) {
      if (actionType === 'add') this.$router.push(`${this.$route.path}/add`);
      else if (actionType === 'edit') {
        localStorage.setItem(`headLine${headLine.id}`, JSON.stringify(headLine));
        this.$router.push(`${this.$route.path}/${headLine.id}/edit`);
      }
    },

    /* Sorting table columns */
    sortBy(sortKey) {
      this.sortKey = sortKey;
      this.sortOrders[sortKey] = !this.sortOrders[sortKey];
      this.sortListBySelectedKey(this.sortKey, this.filteredHeadlines);
    },

    sortListBySelectedKey(sortKey, filteredData) {
      const sortOrder = this.sortOrders[sortKey] ? 'asc' : 'desc';
      this.filteredHeadlines = orderBy(
        filteredData,
        [(entry) => entry[sortKey].toLowerCase()],
        sortOrder
      );
    },

    deleteHeadLines() {
      $('#delete-headline-popup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    navigateToDashboard() {
      this.$router.push('/layout/dashboard');
    }
  }
};
</script>

<style scoped>
.header-wrapper {
  padding: 24px 24px 0px 24px;
}

.list-count {
  line-height: 28px;
}

.limit_popover_txt {
  text-align: left;
  word-break: break-word;
}

.page-title {
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  color: #0b3c61;
  margin-top: 0px;
}

.mt-5 {
  margin-top: 5px;
}

.count-section {
  border-bottom: 1px solid #bdbdbd;
  border-top: 1px solid #bdbdbd;
  padding-top: 16px;
  padding-bottom: 16px;
}

.label-registration {
  margin-bottom: 0px;
  color: rgba(0, 0, 0, 0.7);
}

/* Table styles */
.common-table.table-responsive {
  overflow-y: hidden;
}

.table {
  overflow-x: auto;
  width: 100%;
  margin: -1px;
}

.common-table {
  vertical-align: unset;
}

.common-table .table > thead > tr > th {
  border-bottom: 0;
}

.common-table thead tr {
  border-bottom: 1px dashed #BDBDBD;
}

.common-table .first-col {
  width: 7%;
  text-align: right;
}

.common-table tbody tr:last-child {
  border-bottom: 0 !important;
}

.common-table tbody tr {
  border-bottom: 0.7px solid #bdbdbd;
}

.common-table tr th,
.common-table tr td {
  vertical-align: middle;
}

.common-table tr td.first-col {
  vertical-align: baseline;
}

.common-table tr > .first-col {
  padding-left: 35px !important;
  z-index: 1;
}

.common-table tr > td {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  padding: 16px !important;
}

.common-table th {
  font-size: 14px;
  color: #0b3c61;
  padding: 16px !important;
  border: none;
}

.common-table .table > thead:first-child > tr:first-child > th {
  font-weight: 500;
}

.sort {
  padding-left: 8px;
}

.sort.desc:before {
  content: url('/static/images/icons/sortDesc.svg');
}

.sort.asc:before {
  content: url('/static/images/icons/sortDesc.svg');
  display: inline-block;
  transform: rotate(180deg);
  position: relative;
  top: 2px;
}

.sortPosition:before {
  position: relative;
  top: -1px;
}

tbody tr:hover,
tbody tr.row-active {
  background: #c9e2f4;
}

.w-40p {
  width: 40%;
}

.w-60p {
  width: 60%;
}

.btn-delete {
  color: #b00505 !important;
}

.page-title {
  padding: 0;
}

@media screen and (max-width: 767px) {
  .common-table tr > .sticky {
    position: sticky;
    left: 0;
    background: white;
  }

  .common-table tr > .sticky:hover {
    z-index: 2;
  }

  .common-table tr > .first-col::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
    box-shadow: 3px -1px 4px 0px rgba(0, 0, 0, 0.1);
  }
}
/* Table styles*/
.no-records-found {
  background-color: #f9f9f9;
}
@media screen and (max-width: 657px) {
  .xs-flex-column {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }

  .xs-hide {
    display: none;
  }

  .btn.emergo-green-button {
    border-radius: 50%;
    /* padding: 0px 10px; */
  }
}
</style>
